var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table table-bordered table-hover data-table"},[_c('thead',{staticClass:"thead-dark"},[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{key:column.name,class:_vm.sortKey === column.name
                        ? _vm.sortOrders[column.name] > 0
                            ? 'sorting_asc'
                            : 'sorting_desc'
                        : 'sorting',style:('width:' + column.width + ';' + 'cursor:pointer;'),on:{"click":function($event){return _vm.$emit('sort', column.name)}}},[_vm._v("\n                "+_vm._s(column.label)+"\n            ")])}),0)]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }